import { VerboseFormattingArg } from '@fullcalendar/react';
import { CalendarDateService } from '@uplift/services';
import { CalendarTitle } from './calendar-controls/calendar-title';


export const titleFormatter = (arg: VerboseFormattingArg) => {
  if (arg.start.month !== arg.end?.month) {
    const start = CalendarDateService.date(arg.start.marker).utc();
    const end = CalendarDateService.date(arg.end?.marker).utc();

    return (
      <>
        <CalendarTitle date={start} /> {arg.defaultSeparator} <CalendarTitle date={end} />
      </>
    ) as unknown as string;
  } else if (arg.start.day === arg.end.day) {
    const date = CalendarDateService.date(arg.date.marker).utc();

    return (
      <CalendarTitle date={date} withDate />
    ) as unknown as string;
  }
  const date = CalendarDateService.date(arg.date.marker).utc();

  return (
    <CalendarTitle date={date} />
  ) as unknown as string;
};
